import React from "react";
import {
    Page,
    Document,
    StyleSheet,
    View,
    Text,
    Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        fontFamily: "Helvetica",
        fontSize: 12,
        paddingTop: 35,
        paddingLeft: 35,
        paddingRight: 35,
        lineHeight: 1.5,
        flexDirection: "column",
    },
    title: {
        fontFamily: "Helvetica",
        fontSize: 18,
        marginBottom: 10,
        textAlign: "center",
        fontWeight: "bold",
    },
    section: {
        marginBottom: 10,
    },
    subTitle: {
        fontWeight: "bold",
        fontSize: 14,
    },
    text: {
        fontFamily: "Helvetica",
        fontSize: 12,
        marginBottom: 5,
    },
});

const Contract = ({ formData }: any) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Text style={styles.title}>Contract de scolarizare auto</Text>

                <View style={styles.section}>
                    <Text>Partile implicate in acest contract sunt:</Text>
                    <Text>
                        Scoala.Buzz, inregistrata sub numele de HTTP 402 Payment
                        Required, in continuare denumita &ldquo;Scoala.Buzz&ldquo;;
                    </Text>
                    <Text>
                        Numele cursantului: {formData.fullName}, in continuare
                        denumit &ldquo;Cursantul&ldquo;.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>Obiectul contractului</Text>
                    <Text style={styles.text}>
                        1.1. Prin prezentul contract, Cursantul achizitioneaza
                        prin intermediul Scoala.Buzz un pachet de scolarizare
                        denumit {formData.package} si se angajeaza sa efectueze
                        scolarizarea la una dintre firmele partenere ale
                        Scoala.Buzz, care sunt scoli de soferi autorizate in
                        Bucuresti si Ilfov.
                    </Text>
                    <Text style={styles.text}>
                        1.2. Scoala.Buzz se angajeaza sa faciliteze
                        inregistrarea cursului de scolarizare auto si sa ofere
                        garantia ca Cursantul va beneficia de servicii de
                        scolarizare la tarifele afisate pe site-ul Scoala.Buzz,
                        conform pachetului achizitionat.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>Plata si inregistrarea</Text>
                    <Text style={styles.text}>
                        2.1. Cursantul va achita un avans de 100 de lei catre
                        Scoala.Buzz, prin intermediul platformei de plata
                        Stripe, pentru a confirma inregistrarea sa in procesul
                        de scolarizare auto.
                    </Text>
                    <Text style={styles.text}>
                        2.2. Dupa efectuarea platii, Cursantul va fi contactat
                        in cel mai scurt timp posibil, in aproximativ 24 de ore,
                        de catre un reprezentant al unei scoli de soferi
                        partenere pentru a stabili detaliile ulterioare ale
                        procesului de scolarizare.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>
                        Alegerea autoturismului si zonei de examen
                    </Text>
                    <Text style={styles.text}>
                        3.1. Cursantul are posibilitatea sa-si aleaga
                        autoturismul in care va invata sa conduca si zona de
                        examen preferata.
                    </Text>
                    <Text style={styles.text}>
                        3.2. Cu toate acestea, Scoala.Buzz nu poate garanta
                        disponibilitatea autoturismului sau zonei de examen
                        alese. in cazul in care acestea nu sunt disponibile,
                        Cursantul va fi arondat catre cea mai apropiata zona
                        disponibila sau autoturism disponibil, in functie de
                        disponibilitatea oferita de scolile de soferi partenere.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>
                        Responsabilitati si drepturi
                    </Text>
                    <Text style={styles.text}>
                        4.1. Cursantul se angajeaza sa respecte regulile si
                        instructiunile scolii de soferi partenere si sa
                        participe activ la cursurile teoretice si practice.
                    </Text>
                    <Text style={styles.text}>
                        4.2. Cursantul are dreptul de a beneficia de servicii de
                        scolarizare conforme cu legislatia in vigoare si cu
                        standardele de calitate stabilite de scolile de soferi
                        partenere.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>Anulari si rambursari</Text>
                    <Text style={styles.text}>
                        5.1. Politica de anulare si rambursare a cursului de
                        scolarizare va fi stabilita de catre scoala de soferi
                        partenera la care Cursantul a fost arondat.
                    </Text>
                    <Text style={styles.text}>
                        5.2. Orice modificari sau anulari ale cursului de
                        scolarizare trebuie notificate in scris atat
                        Scoala.Buzz, cat si scolii de soferi partenere, conform
                        politicilor si procedurilor acestora.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>
                        Confidentialitatea datelor
                    </Text>
                    <Text style={styles.text}>
                        6.1. Ambele parti se angajeaza sa respecte
                        confidentialitatea datelor cu caracter personal
                        furnizate in cadrul acestui contract si sa le foloseasca
                        numai in scopurile prevazute de lege si de prezentul
                        contract.
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subTitle}>Forta majora</Text>
                    <Text style={styles.text}>
                        7.1. Niciuna dintre parti nu va fi considerata
                        responsabila pentru nerealizarea sau intarzierea
                        executarii obligatiilor sale prevazute in prezentul
                        contract cauzate de circumstante de forta majora, care
                        nu puteau fi prevazute sau evitate.
                    </Text>
                </View>

                <Text>
                    Prin semnarea acestui contract, Cursantul confirma ca a
                    citit si inteles termenii si conditiile si este de acord sa
                    se supuna acestora.
                </Text>
                <Text> </Text>
                <Text>Semnatura Cursantului: ___________________</Text>
                <Text>Data: ___________________</Text>
                <Text> </Text>
                <Text>Semnatura reprezentantului Scoala.Buzz:</Text>
                <Image src="/sign.png" style={{ marginTop: 20, width: 100 }} />
                <Text>
                    Data:{" "}
                    {new Date()
                        .toLocaleDateString("ro-RO")
                        .split("/")
                        .reverse()
                        .join(" ")}
                </Text>
            </Page>
        </Document>
    );
};

export default Contract;
